import { render, staticRenderFns } from "./AlertMailConfigurationView.vue?vue&type=template&id=657d3a09&lang=pug&"
import script from "./AlertMailConfigurationView.vue?vue&type=script&lang=ts&"
export * from "./AlertMailConfigurationView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports